<template>
  <div>
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-text-field__slot">
          <label
            class="v-label v-label--active theme--light"
          >
            {{ label }}
          </label>
          <div>
            <edit-read-field
              :site="site"
              :active="editable"
              :title="selectTitle"
              :field="editField"
              :type="editType"
              :value="editValue"
              :aid="aid"
              :codelist="codelist"
              :update-params="updateParams"
              @updated="updated"
            >
              <slot></slot>
            </edit-read-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EditReadField from '@/components/EditReadField'
  export default {
    name: 'DisplayField',
    components: { EditReadField },
    props: {
      site: {
        default: undefined,
      },
      label: {
        default: 1,
      },
      editable: {
        default: false,
      },
      editField: {
        default: null,
      },
      editType: {
        default: 'text',
      },
      editTitle: {
        default: null,
      },
      editValue: {
        default: null,
      },
      aid: {
        default: null,
      },
      codelist: {
        default: null,
      },
      updateParams: {
        default: {},
      },
    },
    computed: {
      selectTitle () {
        if (this.editTitle) {
          return this.editTitle
        }
        return this.label
      },
    },
    methods: {
      updated (value) {
        this.$emit('updated', value)
      },
    },
  }
</script>

<style scoped>

</style>
